import React from "react"
import { useTranslation } from "react-i18next"

import { useAlert } from "hooks"
import { Bike } from "models"
import { dateService } from "services/date"
import { DownloadIcon } from "components/Elements"

// PDF
import { pdf } from "@react-pdf/renderer"
import { saveBlob } from "utils/saveBlob"
import { BikeCertificatePDF } from "./pdf"
import { OperatorInterface } from "utils"

export type BikeCertificateProps = {
	bike: Bike
	currentOperator: OperatorInterface
}

export const BikeCertificate: React.FC<BikeCertificateProps> = ({ bike, currentOperator }) => {
	const { t } = useTranslation()
	const { alert } = useAlert()

	const generatePDF = async (event: React.MouseEvent<HTMLButtonElement>, bike: Bike) => {
		event.preventDefault()

		// Manage pdf generation
		const timeStamp = dateService.getCurrentDate("dd-MM-y-HH'h'mm")

		const generateBikePDF =
			bike &&
			currentOperator &&
			(await pdf(<BikeCertificatePDF bike={bike} currentOperator={currentOperator} />)
				.toBlob()
				.then((blob) => {
					saveBlob(
						blob,
						`${t("pdf.bike_certificate_link", {
							ns: "bike",
						})}-${bike?.bike_id}-${timeStamp}.pdf`
					)
					return blob
				})
				.catch((e) => null))

		if (!generateBikePDF) {
			alert("error", t("pdf.pdf_error", { ns: "bike" }))
		}
	}

	return (
		<div className="c-block px-4 py-6 mb-8">
			<button
				type="button"
				className="flex items-center mx-3 text-primary"
				onClick={(e) => generatePDF(e, bike)}
			>
				<DownloadIcon size="27" className="mr-3" color="var(--primaryColor)" />
				{t("pdf.bike_certificate", { ns: "bike" })}
			</button>
		</div>
	)
}
